import React from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";

interface Props {
  label: string;
  children: JSX.Element;
  placement?: string;
}

export default function CustomTooltip({label, children, placement = 'top'}: Props) {
  return (
    // @ts-ignore
    <OverlayTrigger
      overlay={
        <Tooltip>
          <span>{label}</span>
        </Tooltip>
      }
      // @ts-ignore
      placement={placement ?? 'top'}
    >
      {children}
    </OverlayTrigger>
  );
}
